import { useInfiniteRequest } from '@space-shell/common/hooks/useInfiniteRequest'
import type { CommunityMemberRoles } from '@space-shell/common/services/communities'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'

const useGetFollowersRoles = (
  role: CommunityMemberRoles,
  communityId?: number,
  query = '',
  enabled = true
) => {
  return useInfiniteRequest(
    [CommunitiesEndpoints.getFollowersRoles(Number(communityId)), role, query],
    ({ pageParam }) =>
      CommunitiesService.getFollowersRoles(Number(communityId), {
        role,
        q: query ? query : undefined,
        nextPageToken: pageParam
      }),
    {
      getNextPageParam: (lastPage) => lastPage?.nextPageToken ?? undefined,
      enabled: enabled && Boolean(communityId),
      cacheTime: 0
    }
  )
}

export default useGetFollowersRoles
